export const validateSchoolProfileRoleForm = (values) => {
  const errors: any = {};

  if (!values.role) {
    errors.role = "Role is required";
  }

  return errors;
};
